// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, FacebookAuthProvider, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCJcGBnH2AC2SjFvdBxHVfDOmm3-ZUEp24",
  authDomain: "aturno-f3bc4.firebaseapp.com",
  projectId: "aturno-f3bc4",
  storageBucket: "aturno-f3bc4.firebasestorage.app",
  messagingSenderId: "1034849066935",
  appId: "1:1034849066935:web:568222fc0413df23fd9232",
  measurementId: "G-Y0R2CSH5JW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize App Check with better error handling and development support
let appCheck;

try {
  // Check if we're in development mode
  const isDevelopment = process.env.NODE_ENV === 'development' || 
                       window.location.hostname === 'localhost' ||
                       window.location.hostname === '127.0.0.1';

  if (isDevelopment) {
    // In development, use debug mode or disable App Check
    console.log('🔧 Development mode detected - App Check disabled for better debugging');
    
    // Option 1: Disable App Check in development
    appCheck = null;
    
    // Option 2: Use debug mode (uncomment if you want to test App Check in development)
    /*
    appCheck = initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider('6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'), // Google test key
      isTokenAutoRefreshEnabled: true
    });
    
    // Enable debug mode
    if (typeof window !== 'undefined') {
      window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
    }
    */
    
  } else {
    // In production, use real reCAPTCHA
    const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
    
    if (!recaptchaSiteKey) {
      console.warn('⚠️ REACT_APP_RECAPTCHA_SITE_KEY not set. App Check disabled.');
      appCheck = null;
    } else {
      appCheck = initializeAppCheck(app, {
        provider: new ReCaptchaV3Provider(recaptchaSiteKey),
        isTokenAutoRefreshEnabled: true
      });
    }
  }
} catch (error) {
  console.error('❌ Error initializing App Check:', error);
  // Continue without App Check if initialization fails
  appCheck = null;
}

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Configure auth persistence - ensure users stay logged in

// Set persistence to LOCAL to keep users logged in across browser sessions
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log('🔒 Firebase Auth persistence set to LOCAL - users will stay logged in');
  })
  .catch((error) => {
    console.warn('⚠️ Error setting Firebase Auth persistence:', error);
  });

// Initialize social auth providers
export const googleProvider = new GoogleAuthProvider();
export const facebookProvider = new FacebookAuthProvider();

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Cloud Storage and get a reference to the service
export const storage = getStorage(app);

/**
 * Cuánto insiste una subida antes de darse por vencida.
 *
 * De fábrica son 600000 ms: DIEZ MINUTOS. Y mientras reintenta no avisa nada
 * —no hay evento de error, el progreso se queda en 0%—, así que una subida
 * contra un bucket que no existe, o con las reglas mal puestas, no se ve como
 * un error: se ve como una pantalla colgada. Es exactamente lo que pasó al
 * estrenar la subida de la imagen del negocio: el proyecto todavía no tenía
 * Storage habilitado, y el 0% se quedaba quieto sin decir por qué.
 *
 * Treinta segundos alcanzan de sobra para aguantar un bache de conexión —lo
 * que se sube es una imagen ya achicada, de pocos KB— y hacen que cualquier
 * problema de configuración aparezca como un error con su código en vez de
 * como una espera infinita.
 */
storage.maxUploadRetryTime = 30000;

// Initialize Analytics with error handling
let analytics;
try {
  analytics = getAnalytics(app);
} catch (error) {
  console.warn('Analytics initialization failed:', error);
  analytics = null;
}

export { analytics, appCheck };

export default app; 